import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import BoxButtonHeader from '../common/button/boxButtonHeader';
import BoxButtonFooter from '../common/button/boxButtonFooter';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoAtividade, initFormAtividade
} from './manutencaoActions';

class ManutencaoAtividadeForm extends Component {

	state = {
	}

    componentWillMount() {
    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<ContentCardHeader title='Atividade' />
				<Form event={this.props.handleSubmit}>
					<Row>
						<Field
							name='descricao'
							component={LabelAndInput}
							label='Descrição *'
							placeholder='Informe a descrição'
							cols='12 12 12 12'
							readOnly={readOnly} />

						<Field
							name='datahora_inicio'
							component={LabelAndInputDateTime}
							label='Data e Hora Inicial'
							placeholder='Informe o início'
							cols='12 6 6 4'
							readOnly={readOnly} />

						<Field
							name='datahora_fim'
							component={LabelAndInputDateTime}
							label='Data e Hora Final'
							placeholder='Informe o final'
							cols='12 6 6 4'
							readOnly={readOnly} />

						<Field
							name='observacao'
							component={LabelAndInput}
							label='Observação'
							placeholder='Informe observações'
							cols='12 12 12 12'
							readOnly={readOnly} />
					</Row>

					<BoxButtonFooter>
						{this.props.excluir ? (
							<Button
								text='Excluir'
								submit type={'danger'}
								icon={'fa fa-trash'} />
						) : (
							<Button
								text='Salvar'
								submit
								type={'success'}
								icon={'fa fa-check'} />
						)}
						<Button
							text='Cancelar'
							type={'warning'}
							icon={'fa fa-chevron-left'}
							event={() => this.props.setModoAtividade('lista')} />
					</BoxButtonFooter>
				</Form>
			</ContentCard>
        )
    }
}

ManutencaoAtividadeForm = reduxForm({form: 'manutencaoAtividadeForm', destroyOnUnmount: false})(ManutencaoAtividadeForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.manutencao.modoTela,
	registro: state.manutencao.registro,
	formularioValues: getFormValues('manutencaoAtividadeForm')(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoAtividade, initFormAtividade }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ManutencaoAtividadeForm);
